const versions = {
    ui: '8fd7a876aff4c5bf398365815239610818d9010e'
};

export default versions;
